import { Drawer, ErrorState, Skeleton } from '@shared/design-system/ui'
import { useReceivingPlanQuery } from '../api/receiving-plan.queries'
import { planName } from '../model/user-receiving-plan'
import { PlanConditions } from './PlanConditions'

interface Props {
  open: boolean
  onClose: () => void
}

export function ReceivingPlanChangeDrawer({ open, onClose }: Props) {
  const query = useReceivingPlanQuery()
  if (!open) return null
  return (
    <Drawer
      open
      onClose={onClose}
      title={query.data ? `Plano ${planName(query.data.current)}` : 'Plano de recebimento'}
      description="Consulte as taxas, a reserva e os prazos de liberação do saldo."
      size="standard"
    >
      {query.data ? (
        <PlanConditions plan={query.data.current} />
      ) : query.isError ? (
        <ErrorState
          title="Não foi possível carregar o plano"
          onRetry={() => void query.refetch()}
        />
      ) : (
        <Skeleton height={300} />
      )}
    </Drawer>
  )
}
